import { takeLatest, put } from 'redux-saga/effects'
import NProgress from 'nprogress'

import { apiClient } from 'Module/API/Client'

import * as CONST from 'Reducers/Countries/const'
import * as ERRORS from 'Reducers/Errors/const'
import { callApi } from 'Reducers/apiCall'

/**
 * Get countries
 */
function* getCountries() {
  NProgress.start()

  const response = yield callApi(() => apiClient.getCountries())
  const responseJson = yield response.json()

  if (response.ok) {
    yield put({
      type: CONST.GET_COUNTRIES_SUCCESS,
      payload: {
        countries: responseJson,
      },
    })
  } else {
    yield put({
      type: ERRORS.PUSH_API_ERROR,
      error: responseJson,
    })
  }

  NProgress.done()
}

/**
 * Get countries watcher
 */
export function* watchGetCountries() {
  yield takeLatest(CONST.GET_COUNTRIES, getCountries)
}
